function MagicBgInfoBlock({ dictionary, style }) {
	return <div className={style.info}>{dictionary["enter into the input what background you would like"]}</div>;
}

export default MagicBgInfoBlock;
